/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

class ObjectHelper {
    static copyPropertiesToObject(source: any, target: any) {
        for (const key of Object.keys(source)) {
            if (source[key] instanceof Object && !(source[key] instanceof Array)) {
                // Recursively copy nested objects if the property exists in target
                if (key in target && target[key] instanceof Object && !(target[key] instanceof Array)) {
                    ObjectHelper.copyPropertiesToObject(source[key], target[key]);
                }
            } else if (key in target && ((typeof target[key]) === (typeof source[key]))) {
                // Copy properties that exist in the target
                target[key] = source[key];
            }
        }
        return target;
    }

    static removeEmpty(obj: any): any {
        if (Array.isArray(obj)) {
            // Recursively apply removeEmpty to array elements
            return obj
                .map(item => ObjectHelper.removeEmpty(item))
                .filter(item =>
                    item !== null &&
                    item !== undefined &&
                    !(typeof item === 'object' && Object.keys(item).length === 0) &&
                    !(Array.isArray(item) && item.length === 0)
                );
        } else if (typeof obj === 'object' && obj !== null) {
            // Recursively apply removeEmpty to object properties
            return Object.fromEntries(
                Object.entries(obj)
                    .filter(([_, value]) =>
                        value !== null &&
                        value !== undefined &&
                        value !== "" &&
                        !(Array.isArray(value) && value.length === 0) &&
                        !(typeof value === 'object' && Object.keys(value).length === 0)
                    )
                    .map(([key, value]) => [key, ObjectHelper.removeEmpty(value)])
            );
        }
        // Return primitive values directly
        return obj;
    };

    static sortObjectKeys(obj: Record<string, any>): Record<string, any> {
        const sortedObj: Record<string, any> = {};

        Object.keys(obj).sort().forEach(key => {
            const value = obj[key];

            if (value && typeof value === 'object' && !Array.isArray(value)) {
                sortedObj[key] = ObjectHelper.sortObjectKeys(value);
            } else {
                sortedObj[key] = value;
            }
        });

        return sortedObj;
    };

}
export default ObjectHelper;